import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

const nullImage = { assetId: '', alt: '', width: 0, height: 0, url: '' }

function makeBudgetBundleFallback(title: string): BookingSessionBundle {
  return {
    internalName: `Bundle: ${title}`,
    identifier: '',
    title,
    orderSummaryFriendlyName: '',
    tagline: '',
    features: '',
    highlightedFeatures: '',
    listingImage: nullImage,
    listingImageMobile: nullImage,
    detailImage: nullImage,
    badgeLabel: '',
    ctaLabel: '',
    priceLabel: '',
    showPrice: true,
    selectLabel: '',
    recommendedLabel: '',
    galleryLabel: '',
    detailsLabel: '',
    detailPageSlug: '',
    includedScenesLabel: '',
    cartSummaryFeatures: '',
    featureBulletItems: [] as never,
    galleryImages: [],
    upgradeModal: null,
    sessionsListingUpgradeModal: null,
    sceneSelectionPage: null,
    addOnsSelectionPage: null,
    detailPage: null,
    sessionDetailModal: null,
    valueDetails: {
      internalName: `Bundle Value Details: ${title}`,
      restricted: false,
      restrictedWarningText: '',
      restrictedWarningCheckboxLabel: '',
      selectionAlertText: '',
      trending: false,
      trendingLabel: '',
      creditBadgeLabel: '',
      promoText: '',
      promoHighlight: ''
    }
  } as unknown as BookingSessionBundle
}

export const miniBundleFallback = makeBudgetBundleFallback('Mini')

export const essentialBundleFallback = makeBudgetBundleFallback('Essential')
